import { Flex, FlexProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

export const POOSBannerContainer = styled(Flex)<FlexProps>(({ theme }) => ({
  position: 'relative',
  height: '180px',

  [theme.breakpoint.minWidth('md')]: {
    height: '220px'
  },

  [theme.breakpoint.minWidth('lg')]: {
    height: '280px'
  },

  img: {
    opacity: 0.5
  }
}));

export const Banner = styled(Flex)<FlexProps>(({ theme }) => ({
  background: '#ffffffe6',
  borderBottom: `${theme.borderWidth[25]} solid ${theme.color.border.base}`,
  borderTop: `${theme.borderWidth[25]} solid ${theme.color.border.base}`,
  left: 0,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '100%'
}));
